import { ServerProxy } from '../serverProxy/types';
import createBulkAdjustmentServerProxy from '../serverProxy/createBulkAdjustmentServerProxy';
import { useBeaconClientId, useRetailerId, useUserId } from 'src/utils/Hooks/reduxSelectors';

/**
 * Returns a server proxy for bulk adjustments. Any implementation
 * of ServerProxy can be returned.
 *
 */
export default function useServerProxy(): ServerProxy {
  const userId = useUserId();
  const retailerId = useRetailerId();
  const beaconClientId = useBeaconClientId();

  return createBulkAdjustmentServerProxy({
    userId,
    retailerId: +retailerId,
    beaconClientId
  });
}
